<template>
  <div class="row">
    <div class="col-12 col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-12 col-lg-6">
                <label for="title">
                  タイトル <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model="series.title"
                  class="form-control"
                  id="title"
                  placeholder="タイトル入力"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label for="title">説明</label>
                <textarea
                  v-model="series.description"
                  class="form-control"
                  rows="4"
                  id="description"
                  placeholder="説明入力"
                >
                </textarea>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label for="organization">サムネイル画像</label>
                <div class="col-lg-6 offset-lg-3">
                  <div id="thumbnail_field">
                    <img class="img-fluid img-thumbnail mb-2 w-100" v-show="series.thumbnail" :src="series.thumbnail">
                  </div>
                </div>
                <div class="d-flex align-items-center my-3">
                  <div>
                    <label class="d-sm-block">
                      <input type="file" v-on:click="removePreviousThumbnail" v-on:change="thumbnailStartCropping" id="input-series-thumbnail" class="upload-field__input" accept="image/jpeg, image/jpg, image/png" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label for="organization">カバー画像</label>
                <div id="cover_field">
                  <img class="img-fluid img-thumbnail mb-2 w-100" v-show="series.cover" :src="series.cover">
                </div>
                <div class="d-flex align-items-center my-3">
                  <div>
                    <label class="d-sm-block">
                      <input type="file" v-on:click="removePreviousCover" v-on:change="coverStartCropping" id="input-series-cover" class="upload-field__input" accept="image/jpeg, image/jpg, image/png" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="cropper__overlay">
              <div class="cropper__crop-modal"></div>
              <div class="cropper__close-btn" v-on:click="closeCropModal"></div>
              <div class="cropper__select-icon-btn" v-on:click="decideCropArea">決定</div>
            </div>
            <hr />
            <div class="form-row">
              <div class="form-group col-12 col-lg-6">
                <label for="organization">会社</label>
                <el-select
                  v-model="series.organization_id"
                  filterable
                  placeholder="Select"
                  id="organization"
                  class="d-block"
                  @change="fetchVideos()"
                >
                  <el-option
                    v-for="organization in organizations"
                    :key="organization.id"
                    :label="organization.name"
                    :value="organization.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <hr />
            <div class="form-row" v-if="series.organization_id">
              <div class="form-group">
                <label for="video">動画</label>
                <el-transfer
                  v-model="series.video_ids"
                  filterable
                  :titles="['動画', '選択済み']"
                  :data="videos"
                ></el-transfer>
              </div>
            </div>
            <div class="form-group text-right mb-0">
              <button
                type="button"
                @click="submit()"
                class="btn btn-primary waves-effect waves-light"
              >
                更新する
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      series: {
        id: null,
        title: "",
        description: "",
        thumbnail: "",
        cover: "",
        organization_id: null,
        video_ids: [],
      },
      organizations: [],
      videos: [],
      errors: [],
      kind: "",
      canvasRatio: {
        thumbnail: 4/5,
        cover: 5,
      },
      canvasSize: {
        thumbnail: {
          width: 400,
          height: 500,
        },
        cover: {
          width: 1600,
          height: 320,
        },
      }
    };
  },
  async mounted() {
    this.fetchSeries();
    this.fetchOrganizations();
    this.fetchVideos();
  },
  methods: {
    thumbnailStartCropping(e){
      this.kind = "thumbnail"
      this.startCropping(e)
    },
    coverStartCropping(e){
      this.kind = "cover"
      this.startCropping(e)
    },
    startCropping(e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      if (file.type.indexOf('image') < 0) {
        return false;
      }
      var self = this;
      // トリミング画面をフェードインさせる
      reader.onload = function(e) {
        $('.cropper__overlay').fadeIn();
        $('.cropper__crop-modal').append(
          $('<img>').attr({
            src: e.target.result,
            height: '100%',
            width: '100%',
            id: 'crop_img',
            title: file.name,
            style: 'max-width: 100%;'
          })
        );
        self.initIconCrop();
      };
      reader.readAsDataURL(file);
    },
    initIconCrop() {
      let $crop_img = $('#crop_img');
      var self = this;
      $crop_img.cropper({
        dragMode: 'move',
        aspectRatio: this.canvasRatio[this.kind],
        restore: false,
        guides: false,
        center: false,
        ready: function() {
          self.croppable = true;
        },
      });
      this.cropper = $crop_img.data('cropper');
    },
    // トリミング決定時
    decideCropArea() {
      this.iconCropping();
      $('.cropper__overlay').fadeOut();
      $('#crop_img').remove();
      $('.cropper-container').remove();

    },
    closeCropModal() {
      $('.cropper__overlay').fadeOut();
      $('#crop_img').remove();
      $('.cropper-container').remove();
    },
    iconCropping() {
      if ( ! this.croppable) {
        alert('トリミングする画像が設定されていません。');
        return false;
      }
      this.croppedCanvas = this.cropper.getCroppedCanvas({
        width: this.canvasSize[this.kind].width,
        height: this.canvasSize[this.kind].height,
        imageSmoothingQuality: 'high'
      });

      let croppedImage = document.createElement("img");
      croppedImage.src = this.croppedCanvas.toDataURL();
      croppedImage.classList.add("img-fluid", "img-thumbnail", "mb-2", "w-100")

      $(`#${this.kind}_field`).empty();
      $(`#${this.kind}_field`).append(croppedImage);

      const blob = this.base64ToBlob(this.croppedCanvas.toDataURL('image/jpeg'))

      const uniqueKey = Math.random().toString(36).slice(-8);
      this.$set(this.series, this.kind, new File([blob], uniqueKey + this.kind + ".png"));

      this.$forceUpdate();
    },
    base64ToBlob(base64) {
      const bin = atob(base64.replace(/^.*,/, ''));
      const buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      return new Blob([buffer.buffer], {
        type: 'image/png'
      });
    },
    removePreviousThumbnail() {
      $('#input-series-thumbnail').val('');
    },
    removePreviousCover() {
      $('#input-series-cover').val('');
    },
    async fetchSeries() {
      await this.axios
        .get(`${location.pathname}.json`)
        .then((response) => {
          this.$set(this, "series", response.data);
        })
        .catch((error) => {});
    },
    async fetchOrganizations() {
      await this.axios
        .get("/api/v1/admin/organizations", {})
        .then((response) => {
          this.$set(this, "organizations", response.data);
        })
        .catch((error) => {});
    },
    async fetchVideos() {
      await this.axios
        .get("/api/v1/admin/videos", {
          params: { organization_id: this.series.organization_id },
        })
        .then((response) => {
          let videos = response.data.map((video) => {
            return { label: video.title, id: video.id, key: video.id };
          });
          this.$set(this, "videos", videos);
        })
        .catch((error) => {});
    },
    async submit() {
      const url = `/admin/series/${this.series.id}`;
      if (!this.series.title) {
        this.errors.push("タイトルを入力してください。");
      }
      if (!this.series.organization_id) {
        this.errors.push("会社を選択してください。");
      }
      if (this.errors.length) {
        this.errors.forEach((err) => {
          this.$notify({
            group: "information",
            type: "error",
            title: err,
          });
        });
        this.$notify({
          group: "information",
          type: "error",
          title: "入力内容をご確認下さい。",
        });
        this.errors = []
        return false;
      }

      $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        let token;
        if (!options.crossDomain) {
          token = $('meta[name="csrf-token"]').attr('content');

          if (token) {
            return jqXHR.setRequestHeader('X-CSRF-Token', token);
          }
        }
      });

      const formData = new FormData();

      formData.append('series[title]', this.series.title);
      formData.append('series[description]', this.series.description)
      formData.append('series[organization_id]', this.series.organization_id);
      formData.append('series[thumbnail]', this.series.thumbnail);
      formData.append('series[cover]', this.series.cover);

      if(this.series.video_ids.length != 0){
        this.series.video_ids.forEach((video_id) => {
          formData.append('series[video_ids][]', video_id)
        })
      } else {
        formData.append('series[video_ids][]', this.series.video_ids)
      }

      $.ajax({
        url: url + '.json',
        datatype: 'json',
        type: "patch",
        data: formData,
        processData: false,
        contentType: false,
      }).then(
        function(res) {
          const notyf = new Notyf();
          notyf.success('登録が完了しました。');
          $(location).attr("href", url);
        },
        function(res) {
          const notyf = new Notyf();
          notyf.error('エラーが発生しました。');
        }
      );
    },
  },
};
</script>
